import { useState } from "react"
import Typography from "@mui/material/Typography"
import InputLabel from "@mui/material/InputLabel"
import { Grid, styled, Dialog, DialogContent, Box, DialogActions, Button } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import cn from "classnames"
import PropTypes from "prop-types"
import { isArray, isNil } from "lodash"
import { FormattedMessage } from "react-intl"
import TooltipOverflow from "../../TooltipOverflow/TooltipOverflow"
import DialogHeader from "~/components/DialogHeader/DialogHeader"

const HiddenInputLabel = styled(InputLabel)({ visibility: "hidden" })

const HoverableBox = styled(Box, { shouldForwardProp: prop => prop !== "hoverable" })(({ hoverable, theme }) => ({
  cursor: hoverable ? "pointer" : "default",
  display: "inline-block",
  ".hover-icon": { color: theme.palette.grey[600] },
  "&:hover .hover-icon": {
    color: theme.palette.primary.main,
  },
}))

const LabelValueText = ({ className, label, value, reserveLabelSpace, hoverable, dialog }) => {
  const [open, setOpen] = useState(false)

  const formatValue = v => {
    if (isArray(v)) {
      return v.join("\n")
    }
    return v
  }

  let labelComponent = null
  if (label) {
    labelComponent = (
      <InputLabel className="input-label" shrink>
        {label}
      </InputLabel>
    )
  } else if (reserveLabelSpace) {
    labelComponent = <HiddenInputLabel shrink>hidden</HiddenInputLabel>
  }

  const handleOpen = () => {
    if (hoverable) {
      setOpen(true)
    }
  }
  const handleClose = () => setOpen(false)

  return (
    <>
      <HoverableBox alignItems="baseline" onClick={handleOpen} hoverable={hoverable}>
        <Grid container columnSpacing={1}>
          <Grid item xs={12}>
            {labelComponent}
          </Grid>
          <Grid item>
            <TooltipOverflow>
              <Typography
                className={cn(className, hoverable ? "hover-typography" : "")}
                minHeight="1.1876em"
                whiteSpace="pre-wrap"
                variant="body2"
                component="div"
              >
                {!isNil(value) ? formatValue(value) : <FormattedMessage id="type.status.notAvailable" />}
              </Typography>
            </TooltipOverflow>
          </Grid>
          {hoverable && (
            <Grid item>
              <SearchIcon className="hover-icon" />
            </Grid>
          )}
        </Grid>
      </HoverableBox>

      {hoverable && dialog && (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogHeader onClose={handleClose}>{dialog.title}</DialogHeader>
          <DialogContent>{dialog.Content}</DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              <FormattedMessage id="action.close" />
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}

LabelValueText.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node, PropTypes.array]),
  reserveLabelSpace: PropTypes.bool,
  hoverable: PropTypes.bool,
  dialog: PropTypes.object,
}

LabelValueText.defaultProps = {
  className: "",
  value: "",
  reserveLabelSpace: false,
  hoverable: false,
  dialog: null,
}

export default LabelValueText
